// Text matching for the command palette and the help search: case and
// accents do not matter, so "reglementaire" finds "Réglementaire" and
// "pep" finds "PEP".

/** Lower case, accents removed, spaces collapsed. */
export function fold(s) {
  return String(s ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * How well `query` matches `fields` (strings, the first being the title):
 * 0 for no match. Every word of the query must appear somewhere; a title
 * that starts with the query scores highest, then a title that holds it,
 * then a word found only in the other fields.
 */
export function matchScore(query, fields) {
  const q = fold(query);
  if (!q) return 1;
  const folded = fields.map(fold);
  const title = folded[0] || "";
  const all = folded.join(" ");
  const words = q.split(" ");
  if (!words.every((w) => all.includes(w))) return 0;
  if (title.startsWith(q)) return 4;
  if (title.includes(q)) return 3;
  if (words.every((w) => title.includes(w))) return 2;
  return 1;
}
